// test1592
(1592 && 0);
